'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { getAdSpendCurrencyChoice } from 'AdsUI/selectors/AdProfileSelectors';
import { hasAccessToRoiReporting } from 'AdsUI/selectors/AuthSelectors';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
const ROI_SETTINGS = `/settings/${PortalIdParser.get()}/marketing/ads/roiCalculation`;

const RoiSettingsLink = ({
  className,
  children
}) => /*#__PURE__*/_jsx(UILink, {
  href: ROI_SETTINGS,
  className: className,
  children: children
});

const AdSpendCurrencyChoiceLink = ({
  block = false,
  messageJsx
}) => {
  const adSpendCurrencyChoice = useSelector(getAdSpendCurrencyChoice);
  const hasRoiReporting = useSelector(hasAccessToRoiReporting);

  if (!hasRoiReporting) {
    return null;
  }

  return messageJsx ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: {
      RoiSettingsLink
    },
    message: messageJsx
  }) : /*#__PURE__*/_jsx(RoiSettingsLink, {
    className: block && 'display-block',
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `campaigns.multiCurrencyTooltip.adSpendCurrencyChoiceLink.${adSpendCurrencyChoice}`
    })
  });
};

AdSpendCurrencyChoiceLink.propTypes = {
  block: PropTypes.bool,
  messageJsx: PropTypes.string
};
export default AdSpendCurrencyChoiceLink;